module.exports = __webpack_public_path__ + "img/59_1.d86a6124.png";